import { MenuItem } from 'config/types'
import { ActionQueryEnum } from 'hooks/useActionQueryListener'
import PromotionExpandContent from 'layout/Components/Menu/PromotionExpandContent'
import { RouteConfig } from './route'

export const MENU_ITEMS: MenuItem[] = [
  {
    icon: 'GameIcon',
    content: 'Games',
    route: RouteConfig.Games,
    id: 'games',
    subMenu: [
      {
        content: 'Favorites',
        route: RouteConfig.FavoriteGames,
        id: 'favorites',
        onlySignedUser: true,
      },
      {
        content: 'Recent',
        route: RouteConfig.RecentGames,
        id: 'recent',
        onlySignedUser: true,
      },
    ],
  },
  {
    icon: 'ProviderIcon',
    content: 'Provider',
    route: RouteConfig.Providers,
    id: 'providers',
  },
  {
    icon: 'TransactionHistoryIcon',
    content: 'Transaction History',
    route: RouteConfig.DepositTransactionHistory,
    id: 'transition-history',
    onlySignedUser: true,
  },
  {
    icon: '/promotion.png',
    content: 'Promotions',
    route: RouteConfig.Promotions,
    ExpandComponent: PromotionExpandContent,
    id: 'promotions',
  },
  {
    icon: 'StakeIcon',
    content: 'Staking',
    route: RouteConfig.Stake,
    id: 'staking',
  },
  {
    icon: 'VIPClubIcon',
    content: 'VIP Club',
    route: RouteConfig.VIPClub,
    id: 'vip',
  },
  {
    icon: 'ReferralIcon',
    content: 'Referral',
    route: RouteConfig.Referral,
    id: 'referral',
    isNew: true,
  },
  {
    icon: 'HunnyPokerIcon',
    content: 'HunnyPoker',
    route: RouteConfig.HunnyPoker,
    external: true,
    id: 'hunnypoker',
    attributes: {
      rel: 'nofollow',
    },
  },
  {
    icon: 'SupportIcon',
    content: 'Support',
    route: `?action=${ActionQueryEnum.OpenSupportChat}`,
  },
  {
    icon: 'NewsIcon',
    content: 'News',
    route: RouteConfig.News,
  },
  {
    icon: 'CardIcon',
    content: 'Gambling Hub',
    route: RouteConfig.Blogs,
    closedAfterClick: true,
  },
]
